<template>
  <v-container class="text-center">
    <h2 style="text-align: center; border-style: solid; border-radius: 50px">
      1. Schritt: Projekteinrichtung
    </h2>
    <br />
    <h3>
      Hier kannst du Projekte, Firmen, Standorte und Schichten neu anlegen oder
      auswählen, bevor du neue Adressen hochlädst.
    </h3>
    <h3>
      Damit werden die neuen Adressen direkt dem richtigen Projekt zugeordnet.
    </h3>
    <v-select
      v-model="selectedProjectId"
      :items="projects"
      :item-title="'name'"
      :item-value="'id'"
      :error-messages="projectsError"
      label="Projekt"
      id="test"
    ></v-select>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message:
          'Sie haben keine Berechtigung, ein neues Projekt zu erstellen!',
      }"
      @click="showForm('project', 'post')"
      :icon="true"
      ><v-icon icon="mdi-plus"></v-icon
    ></v-btn>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message: 'Sie haben keine Berechtigung, dieses Projekt zu bearbeiten!',
      }"
      @click="showForm('project', 'put')"
      :disabled="!selectedProjectId"
      :icon="true"
      ><v-icon icon="mdi-pencil"></v-icon
    ></v-btn>
    <br />
    <fade-transition
      :open="show.project"
      v-if="
        authStore.hasRole('simple-user') || authStore.hasRole('licence-manager')
      "
    >
      <project-form
        :mode="mode.project"
        @hide-form="show.project = false"
        :name="selectedProject.name"
        :currentId="selectedProjectId"
        @post-project="show.project = false"
        @put-project="show.project = false"
        @delete-project="show.project = false"
      ></project-form>
    </fade-transition>
    <v-select
      v-model="selectedCompanyId"
      :items="companies"
      :item-title="'name'"
      :item-value="'id'"
      label="Firma"
    ></v-select>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message: 'Sie haben keine Berechtigung, eine neue Firma zu erstellen!',
      }"
      @click="showForm('company', 'post')"
      :icon="true"
      :disabled="!selectedProjectId"
      ><v-icon icon="mdi-plus"></v-icon
    ></v-btn>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message: 'Sie haben keine Berechtigung, diese Firma zu bearbeiten!',
      }"
      @click="showForm('company', 'put')"
      :disabled="!selectedCompanyId"
      :icon="true"
      ><v-icon icon="mdi-pencil"></v-icon
    ></v-btn>
    <br />
    <fade-transition
      :open="show.company"
      v-if="
        authStore.hasRole('simple-user') || authStore.hasRole('licence-manager')
      "
    >
      <company-form
        :mode="mode.company"
        @hide-form="show.company = false"
        :name="selectedCompany.name"
        :currentId="selectedCompanyId"
        :projectId="selectedProjectId"
        @post-company="show.company = false"
        @put-company="show.company = false"
        @delete-company="show.company = false"
      ></company-form>
    </fade-transition>
    <v-select
      v-model="selectedOfficeId"
      :items="offices"
      :item-title="'office_name'"
      :item-value="'office_id'"
      label="Standort"
    ></v-select>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message:
          'Sie haben keine Berechtigung, einen neuen Standort zu erstellen!',
      }"
      @click="showForm('office', 'post')"
      :icon="true"
      :disabled="!selectedCompanyId"
      ><v-icon icon="mdi-plus"></v-icon
    ></v-btn>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message: 'Sie haben keine Berechtigung, diesen Standort zu bearbeiten!',
      }"
      @click="showForm('office', 'put')"
      :disabled="!selectedOfficeId"
      :icon="true"
      ><v-icon icon="mdi-pencil"></v-icon
    ></v-btn>
    <br />
    <fade-transition
      :open="show.office"
      v-if="
        authStore.hasRole('simple-user') || authStore.hasRole('licence-manager')
      "
    >
      <office-form
        :mode="mode.office"
        @hide-form="show.office = false"
        :name="selectedOffice['office_name']"
        :street="selectedOffice['street']"
        :house_number="selectedOffice['house_number']"
        :postal_code="selectedOffice['postal_code']"
        :district="selectedOffice['district']"
        :currentId="selectedOfficeId"
        :projectId="selectedProjectId"
        :companyId="selectedCompanyId"
        :adressId="selectedOffice['adress_id']"
        @post-office="show.office = false"
        @put-office="show.office = false"
        @delete-office="show.office = false"
      >
      </office-form>
    </fade-transition>
    <v-select
      v-model="selectedShiftId"
      :items="shifts"
      :item-title="'name'"
      :item-value="'id'"
      label="Schicht"
    ></v-select>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message:
          'Sie haben keine Berechtigung, eine neue Schicht zu erstellen!',
      }"
      @click="showForm('shift', 'post')"
      :icon="true"
      :disabled="!selectedOfficeId"
      ><v-icon icon="mdi-plus"></v-icon
    ></v-btn>
    <v-btn
      v-auth-click="{
        roles: ['simple-user', 'licence-manager'],
        message: 'Sie haben keine Berechtigung, diese Schicht zu bearbeiten!',
      }"
      @click="showForm('shift', 'put')"
      :disabled="!selectedShiftId"
      :icon="true"
      ><v-icon icon="mdi-pencil"></v-icon
    ></v-btn>
    <br />
    <fade-transition
      :open="show.shift"
      v-if="
        authStore.hasRole('simple-user') || authStore.hasRole('licence-manager')
      "
    >
      <shift-form
        :mode="mode.shift"
        @hide-form="show.shift = false"
        :name="selectedShift.name"
        :start="selectedShift.start"
        :end="selectedShift.end"
        :flextime="selectedShift.flextime"
        :officeId="selectedOfficeId"
        :currentId="selectedShiftId"
        @delete-shift="show.shift = false"
        @post-shift="show.shift = false"
        @put-shift="show.shift = false"
      ></shift-form>
    </fade-transition>
    <v-btn @click="reset" :disabled="!selectedProjectId" :icon="true"
      ><v-icon icon="mdi-refresh"></v-icon
    ></v-btn>
  </v-container>
  <v-container>
    <the-single-file-upload
      :selectedProjectId="selectedProjectId"
      :selectedCompanyId="selectedCompanyId"
      :selectedOfficeId="selectedOfficeId"
      :selectedShiftId="selectedShiftId"
      :companyOffices="companyOffices"
      :officeShifts="officeShifts"
      ref="singleFileUpload"
    ></the-single-file-upload>
  </v-container>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useOfficeStore } from "../store/officeStore";
import { useAuthStore } from "../store/authStore";
import ProjectForm from "./Forms/FormProject.vue";
import CompanyForm from "./Forms/FormCompany.vue";
import ShiftForm from "./Forms/FormShift.vue";
import { mapStores } from "pinia";
import OfficeForm from "./Forms/FormOffice.vue";
import { formatTime } from "../utils/strings";
import FadeTransition from "./Animations/FadeTransition.vue";
import TheSingleFileUpload from "./TheSingleFileUpload.vue";

export default defineComponent({
  components: {
    ProjectForm,
    CompanyForm,
    OfficeForm,
    ShiftForm,
    FadeTransition,
    TheSingleFileUpload,
  },
  setup() {
    const authStore = useAuthStore();
    const officeStore = useOfficeStore();

    return {
      authStore,
      officeStore,
    };
  },
  data() {
    return {
      selectedProjectId: null,
      selectedCompanyId: null,
      selectedOfficeId: null,
      selectedShiftId: null,
      mode: {
        project: "post" as "post" | "put",
        company: "post" as "post" | "put",
        office: "post" as "post" | "put",
        shift: "post" as "post" | "put",
      },
      show: {
        project: false,
        company: false,
        office: false,
        shift: false,
      },
      companyOffices: [] as object[],
      officeShifts: [] as object[],
      projectsError: [],
      dialog: false,
    };
  },
  computed: {
    ...mapStores(useOfficeStore),
    projects() {
      // @ts-ignore
      return this.officeStore.getProjects;
    },
    companies() {
      // @ts-ignore
      return this.officeStore.getCompanies;
    },
    offices() {
      // @ts-ignore
      return this.officeStore.getOffices;
    },
    shifts() {
      // @ts-ignore
      return this.officeStore.getShifts;
    },
    adresses() {
      // @ts-ignore
      return this.officeStore.getAdresses;
    },
    selectedProject() {
      // @ts-ignore
      let selected = this.projects.find((val: object) => {
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedProjectId) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
    selectedCompany() {
      // @ts-ignore
      let selected = this.companies.find((val: object) => {
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedCompanyId) {
            return true;
          }
        }
        return false;
      });
      // return fallback
      if (!selected) {
        return { name: null, id: null };
      }
      return selected;
    },
    selectedOffice() {
      // @ts-ignore
      let selected: object = this.offices.find((val: object) => {
        // @ts-ignore
        if (val["office_id"]) {
          // @ts-ignore
          if (val["office_id"] === this.selectedOfficeId) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return {
          name: null,
          type: null,
          owner: null,
          street: null,
          house_number: null,
          postal_code: null,
          district: null,
          geo: {
            coordinates: [null, null],
          },
        };
      }
      return selected;
    },
    selectedShift() {
      // @ts-ignore
      let selected = this.shifts.find((val: object) => {
        // @ts-ignore
        if (val.id) {
          // @ts-ignore
          if (val.id === this.selectedShiftId) {
            return true;
          }
        }
        return false;
      });
      if (!selected) {
        return {
          name: null,
          start: null,
          end: null,
          flextime: false,
        };
      }
      if (selected.start) {
        selected.start = formatTime(selected.start);
      }
      if (selected.end) {
        selected.end = formatTime(selected.end);
      }
      return selected;
    },
  },
  created() {
    this.officeStore.fetchProjects();
  },
  mounted() {
    this.officeStore.$reset();
  },
  watch: {
    async selectedProjectId(newVal, oldVal) {
      console.log("Selected Project-ID: ", this.selectedProjectId);

      if (newVal != oldVal) {
        this.selectedCompanyId = null;
        this.selectedOfficeId = null;
        this.selectedShiftId = null;
        this.show.project = false;
        this.show.company = false;
        this.show.shift = false;
        this.show.office = false;
        await this.officeStore.fetchCompanies(newVal);
      }
    },
    async selectedCompanyId(newVal, oldVal) {
      console.log("Selected Company-ID: ", this.selectedCompanyId);

      if (newVal != oldVal) {
        this.selectedOfficeId = null;
        this.selectedShiftId = null;
        this.show.company = false;
        this.show.office = false;
        this.show.shift = false;
        console.log("Selected Project-ID: ", this.selectedProjectId);
        console.log("New Value: ", newVal);

        if (this.selectedProjectId) {
          console.log("Fetching Offices");
          console.log("Company Offices: ", this.companyOffices);

          this.companyOffices = await this.officeStore.fetchOffices(
            this.selectedProjectId,
            newVal,
          );
          console.log(
            "Company Offices after fetchOffices: ",
            this.companyOffices,
          );
        } else {
          console.warn(
            `unable to fetch offices, because selected company-id: ${this.selectedCompanyId} is a falsey value`,
          );
        }
      }
    },
    async selectedOfficeId(newVal, oldVal) {
      console.log("Selected Office-ID: ", this.selectedOfficeId);
      if (newVal != oldVal) {
        this.selectedShiftId = null;
        this.show.office = false;
        this.show.shift = false;
        this.officeShifts = await this.officeStore.fetchShifts(newVal);
      }
    },
    async selectedShiftId(newVal, oldVal) {
      console.log("Selected Shift-ID: ", this.selectedShiftId);
      if (newVal != oldVal) {
        this.show.shift = false;
      }
    },
  },
  methods: {
    showForm(form: string, mode: string) {
      // @ts-ignore
      if (this.mode[form]) {
        // @ts-ignore
        this.mode[form] = mode;
        // @ts-ignore
        this.show[form] = true;
      } else {
        console.warn(
          `used showForm with key ${form}, which is not a valid key`,
        );
      }
    },
    reset() {
      this.selectedProjectId = null;
      this.selectedCompanyId = null;
      this.selectedOfficeId = null;
      this.selectedShiftId = null;
      this.show.company = false;
      this.show.shift = false;
      this.show.office = false;
      this.officeStore.$reset();
      this.officeStore.fetchProjects();
      // Call the reset() function of the TheSingleFileUpload component
      this.$refs.singleFileUpload.reset();
    },
  },
});
</script>

<style scoped>
.v-combobox {
  width: 40%;
  display: inline-block;
  vertical-align: top;
}
.v-select {
  width: 40%;
  display: inline-block;
  vertical-align: top;
}
.v-file-input {
  width: 40%;
  display: inline-grid;
  vertical-align: top;
}
.v-btn {
  margin: 0px 3px;
}
</style>
